import { createContext, ReactNode, useMemo } from 'react';
import AnalyticsService from 'utils/analytics';
import { analyticsConfig, appConfig } from 'config';

export const QuantumContext = createContext<AnalyticsService | null>(null);

interface IQuantumContextProviderProps {
  children: ReactNode;
}

export const QuantumContextProvider = ({
  children,
}: IQuantumContextProviderProps) => {
  const analytics = useMemo(
    () => new AnalyticsService(analyticsConfig, appConfig.version),
    []
  );

  return (
    <QuantumContext.Provider value={analytics}>
      {children}
    </QuantumContext.Provider>
  );
};
